import React from 'react';
import printJS from 'print-js';
import apiService from 'apiService';

const PrintButton = ({ url, buttonText = 'print' }) => {
  const requestFile = async (url) => {
    const res = await apiService.getblob(url);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  return <button className='btn btn-sm btn-neutral' onClick={() => requestFile(url)}>
    <span className="btn-inner--icon"><i className="fa fa-print"></i></span>
    <span className="btn-inner--text"> {buttonText}</span>
  </button>;
};

export default PrintButton;
